import {useEffect, useState} from "react";
import useStyles from "../Footer/useStyles";
import {Button, Tooltip} from "@mui/material";
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import {useSelector} from "react-redux";
import ModalAlertsDialog from "../ModalAlertsDialog";

const fieldEcriptor = {
    projects: 'Проектов',
    trackers: 'Трекеров',
    geozones: 'Геозон',
    alarms: 'Тревог',
    company: 'Компания'
}

const INTERVAL_TO_REQUEST_FOOTER_INFO = 60000

const Footer = () => {

    const classes = useStyles()
    const role = useSelector(s => s?.user?.role);
    const footerInfo = useSelector(s => s?.api?.footerInfo?.data) || {};
    const alarmsInfo = useSelector(s => s?.api?.alarmsInfo?.data) || {};
    const getFooterInfo = useSelector(s => s?.service?.Api?.getFooterInfo) || (() => {});
    const getAlarmsInfo = useSelector(s => s?.service?.Api?.getAlarmsInfo) || (() => {});

    const [showAlertsDialog, setShowAlertsDialog] = useState(false)

    useEffect(() => {
        getFooterInfo();
        getAlarmsInfo()

        const intervalId = setInterval(() => {
            getFooterInfo();
            getAlarmsInfo()
        }, INTERVAL_TO_REQUEST_FOOTER_INFO);

        return () => clearInterval(intervalId);
    }, []);

    const availableField = Object.keys(footerInfo)

    let centerPartValues;

    if (availableField?.length) {
        centerPartValues = availableField
            .map((k) => {
                const key = fieldEcriptor?.[k];
                const value = footerInfo?.[k];
                return {key, value};
            })
            .filter(({key, value}) => key !== undefined && value !== undefined);
    } else {
        centerPartValues = [{key: "Загрузка", value: ""}];
    }

    const showAlertsDetails = () => {
        setShowAlertsDialog(true)
    }

    const closeAlertsDialog = () => {
        setShowAlertsDialog(false)
    }

    return (
        <footer className={classes.footer}>

            <div className={classes.footerContainer}>
                <div className={classes.leftPart}>
                    <p className={classes.footerText}>ЭЛПАТ версия 1.19-03.</p>
                </div>
                <div className={classes.centerPart}>
                    {centerPartValues.map(centerValue => (
                        <div className={classes.footerTextBlock} key={centerValue.key}>

                            {centerValue.key === "Тревог" ? (
                                <Tooltip
                                    title="Детали"
                                    placement="top"
                                    PopperProps={{
                                        modifiers: [
                                            {
                                                name: 'offset',
                                                options: {
                                                    offset: [0, -10], // Сбросить смещение по вертикали
                                                },
                                            },
                                        ],
                                    }}
                                >
                                    <Button
                                        className={classes.footerTextBlock}
                                        onClick={showAlertsDetails}
                                    >
                                        <p className={classes.footerKey}>{centerValue.key}</p>
                                        <p className={classes.footerText}>{centerValue.value}</p>
                                    </Button>
                                </Tooltip>
                            ) : (
                                <>
                                    <p className={classes.footerKey}>{centerValue.key}</p>
                                    <p className={classes.footerText}>{centerValue.value}</p>
                                </>
                            )}

                        </div>
                    ))}

                    {role ? (
                        <div className={classes.footerTextBlock}>
                            <p className={classes.footerKey}>
                                <Tooltip title="Скачать инструкцию">
                                    <a href={`/pdf/doc_${role}.pdf`} download
                                       style={{position: "relative", top: "1px"}}>
                                        <HelpCenterIcon fontSize="small" htmlColor="#FFF"/>
                                    </a>
                                </Tooltip>
                            </p>
                        </div>
                    ) : null}

                </div>
                <div className={classes.rightPart}>
                    <p className={classes.footerText}>(С) Группа строительных компаний
                        “ДОН”, {new Date().getFullYear()}</p>
                </div>
            </div>

            {showAlertsDialog && (
                <ModalAlertsDialog
                    onClose={closeAlertsDialog}
                    open={showAlertsDialog}
                    okText="Закрыть"
                    alarmsInfo={alarmsInfo}
                />
            )}

        </footer>
    );
}

export default Footer;